import { Options, Vue } from 'vue-class-component';

import config from '@/config/config';
import PageBaseView from '@/pages/PageBaseView';
import * as DocumentTypeService from '@/services/document-type.service';
import { IDocumentType } from '@/domain/document-type.model';

@Options({
  name: 'document-type-view',
  props: {
    id: String,
  },
})
export default class DocumentTypeView extends PageBaseView {
  public row: IDocumentType = {
    description: '',
    extensions_enabled: [],
    enabled: false,
  };

  public mounted(): void {
    this.url = 'document-type';
    this.module = config.modules.documentType;

    DocumentTypeService.get(this.id)
      .then((res: IDocumentType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = 'Registro não encontrado.';
        }
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.';
      });
  }
}
